<mat-form-field appearance="outline" class="flex w-[292px] pt-[1.5rem]">
  <input class="w-16" matInput [matDatepicker]="picker" i18n-placeholder placeholder="Start date and time"
    [formControl]="singleDateTimeService.getDateFormControl()">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker panelClass="h-[558px] date-time-range-picker">
    <mat-datepicker-actions>
      <div class="h-[130px] flex items-center">
        <lib-time-picker #timePicker [label]="timeLabel"
          [formGroup]="singleDateTimeService.getTimeFormGroup()"></lib-time-picker>
      </div>
      <div>
        @if (getErrorMessage()) {
        <mat-error class="!flex pl-2 max-w-[296px]">
          {{getErrorMessage()}}
        </mat-error>
        }
      </div>
      <div class="solid !w-[100%]"></div>
      <div class="flex self-end gap-[7px] h-[60px] pr-[8px] action-buttons">
        <button mat-button matDatepickerCancel i18n (click)="onCancel($event)">Cancel</button>
        <button mat-button matDatepickerApply i18n (click)="onSubmit($event)" [disabled]="shouldDisableApplyButton()">Apply</button>
      </div>
    </mat-datepicker-actions>
  </mat-datepicker>
</mat-form-field>